<template>
    <div
        class="cart-preview-button fixed right-6 z-[49]"
        :class="hasItems ? 'bottom-6' : 'bottom-6 opacity-60'"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
    >
        <!-- Dropdown popover (desktop only) -->
        <Transition name="cart-pop">
            <div
                v-if="showPopover && !isMobile()"
                class="cart-popover absolute bottom-[calc(100%+12px)] right-0 w-72 bg-white rounded-2xl shadow-2xl border border-black/8 overflow-hidden"
                @mouseenter="onMouseEnter"
                @mouseleave="onMouseLeave"
            >
                <!-- Header -->
                <div class="flex items-center gap-2 px-4 py-3 border-b border-gray-100">
                    <svg class="w-5 h-5 text-gray-700" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor">
                        <path d="M551.991 64H144.28l-8.726-44.608C133.35 8.128 123.478 0 112 0H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h80.24l69.594 355.701C150.796 415.201 144 430.802 144 448c0 35.346 28.654 64 64 64s64-28.654 64-64a63.681 63.681 0 0 0-8.583-32h145.167a63.681 63.681 0 0 0-8.583 32c0 35.346 28.654 64 64 64 35.346 0 64-28.654 64-64 0-18.136-7.556-34.496-19.676-46.142l1.035-4.757c3.254-14.96-8.142-29.101-23.452-29.101H203.76l-9.39-48h312.405c11.29 0 21.054-7.869 23.452-18.902l45.216-208C578.695 78.139 567.299 64 551.991 64z"/>
                    </svg>
                    <span class="font-semibold text-gray-800">Cart</span>
                    <span v-if="hasItems" class="badge-inline ml-auto">{{ cartCount }}</span>
                </div>

                <!-- Tour list -->
                <ul v-if="hasItems" class="divide-y divide-gray-50 max-h-64 overflow-y-auto">
                    <li
                        v-for="trip in trips"
                        :key="trip.tour_id"
                        class="flex items-center gap-3 px-4 py-3"
                    >
                        <img
                            :src="getTourImage(trip.tour_id)"
                            :alt="getTourName(trip.tour_id)"
                            class="w-12 h-12 object-cover rounded-lg shrink-0 bg-gray-100"
                        />
                        <span class="text-sm text-gray-700 leading-snug">{{ getTourName(trip.tour_id) }}</span>
                    </li>
                </ul>
                <div v-else class="px-4 py-4 text-sm text-gray-400 text-center">Your cart is empty</div>

                <!-- Footer CTA -->
                <div v-if="hasItems" class="px-4 py-3 bg-gray-50 border-t border-gray-100">
                    <router-link
                        to="/cart"
                        class="block text-center text-sm font-semibold no-underline hover:no-underline button button-pink-book w-full py-2 rounded-lg"
                    >
                        View Cart
                    </router-link>
                </div>

                <!-- Caret -->
                <div class="absolute -bottom-2 right-5 w-4 h-4 bg-white border-r border-b border-black/8 rotate-45 shadow-sm"></div>
            </div>
        </Transition>

        <!-- The button itself -->
        <router-link
            to="/cart"
            class="cart-btn flex items-center gap-2 px-5 py-3 rounded-full shadow-lg no-underline hover:no-underline transition-all duration-200 select-none"
            :class="hasItems ? 'cart-btn--active' : 'cart-btn--empty'"
            role="button"
            :aria-label="`Cart, ${cartCount} item${cartCount !== 1 ? 's' : ''}`"
        >
            <svg class="w-5 h-5 shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor">
                <path d="M551.991 64H144.28l-8.726-44.608C133.35 8.128 123.478 0 112 0H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h80.24l69.594 355.701C150.796 415.201 144 430.802 144 448c0 35.346 28.654 64 64 64s64-28.654 64-64a63.681 63.681 0 0 0-8.583-32h145.167a63.681 63.681 0 0 0-8.583 32c0 35.346 28.654 64 64 64 35.346 0 64-28.654 64-64 0-18.136-7.556-34.496-19.676-46.142l1.035-4.757c3.254-14.96-8.142-29.101-23.452-29.101H203.76l-9.39-48h312.405c11.29 0 21.054-7.869 23.452-18.902l45.216-208C578.695 78.139 567.299 64 551.991 64z"/>
            </svg>
            <span class="font-semibold text-sm">Cart</span>
            <span
                class="cart-badge ml-1 min-w-[1.25rem] h-5 px-1 rounded-full text-xs font-bold flex items-center justify-center"
                :class="hasItems ? 'cart-badge--active' : 'cart-badge--empty'"
            >
                {{ cartCount }}
            </span>
        </router-link>
    </div>
</template>

<script lang="ts" src="./cart_preview_button.ts"></script>

